import SearchComponent from "../../components/search.component";
import {SORT_LIST_AVOSTORE} from "../../utils/sort-list";
import {STATE_LIST_GENERAL} from "../../utils/state-list";
import ExportComponent from "../../components/export.component";
import ChangeStateComponent from "../../components/change-state.component";
import FilterCityComponent from "../../components/filter-city.component";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useDispatch, useSelector} from "react-redux";
import {
    setToolsAlertMessage,
    setToolsAlertType,
    setToolsModalVisibility,
    setToolsReload
} from "../../reducers/tools.reducer";
import {setAvostoreSelectedRowKeys} from "../../reducers/avostore.reducer";
import {downloadFileExport} from "../../utils/general-variable";
import moment from "moment/moment";
import SortComponent from "../../components/sort.component";
import PageLimitComponent from "../../components/page-limit.component";
import {DATA_LIMIT_LIST} from "../../utils/filter-list";
import React from "react";

const AvoStoreFilter = () => {
    const dispatch = useDispatch()
    const {selectedRowKeysAvostore} = useSelector(state => state.avostoreReducer)
    const {data: areaList} = useFetch(API.AREA_LIST, {simplified: true}, {isFetching: true})
    const {fetching: postUpdateStatus, isLoading: loadingUpdateState} = useFetch(API.AVOSTORE_UPDATE_STATUS)
    const {fetching: exportAvostoreList, isLoading: loadingExport} = useFetch(API.EXPORT_AVOSTORE_LIST)
    const {
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)

    const applyStatusHandler = (listId, status) => {
        const body = {
            avostore_ids: listId,
            action: status
        }
        postUpdateStatus(body).then(() => {
            const message = status === 'delete' ? 'Delete Data Successfully' : 'Avostore State Updated'
            showAlertModal('success', message)
        }).catch(err => {
            showAlertModal('warning', `${err?.message}`)
        })
        dispatch(setAvostoreSelectedRowKeys([]))
    }

    const showAlertModal = (type, message) => {
        dispatch(setToolsModalVisibility({alert: true}))
        dispatch(setToolsAlertType(type))
        dispatch(setToolsAlertMessage(message))
        dispatch(setToolsReload(!reload))
    }

    const exportDataHandler = () => {
        const body = {
            order_by: orderBy ?? 'id',
            order_type: sort,
            filter_by_area_id: filter ?? [],
            search: searchKey,
            avostore_ids: selectedRowKeysAvostore
        }
        exportAvostoreList(body, '', {}, 'blob').then(res => {
            downloadFileExport(res, `Avostore-List-Export-${moment().format()}.xlsx`)
        })
        dispatch(setToolsModalVisibility({export: false}))
    }

    const filterListCustomer = [
        {
            title: 'Area / Kota',
            list: areaList?.data ?? []
        }
    ]

    return (
        <div className={"row justify-between my-5"}>
            <div className={"row space-x-5"}>
                <SearchComponent placeholder={"cari store..."}/>
                <div className={"row space-x-3"}>
                    <SortComponent sortList={SORT_LIST_AVOSTORE}/>
                    <FilterCityComponent filterList={filterListCustomer} placeholder={"cari area / Kota..."}
                                         labelName={'name'} keyName={'id'}/>
                    <PageLimitComponent limitList={DATA_LIMIT_LIST}/>
                    <div>
                        <ExportComponent
                            wordingConfirmation={`Apakah anda yakin ingin melakukan export data avostore ?`}
                            countSelected={selectedRowKeysAvostore.length}
                            exportDataHandler={exportDataHandler}
                            isLoading={loadingExport}/>
                    </div>
                </div>
            </div>
            <ChangeStateComponent
                wordingConfirmation={"Apakah anda ingin mengubah status avostore yang anda pilih ?"}
                wordingDeleteConfirmation={"Apakah anda yakin menghapus avostore yang anda pilih ?"}
                selectedRow={selectedRowKeysAvostore}
                stateList={STATE_LIST_GENERAL}
                isLoading={loadingUpdateState}
                applyStatusHandler={applyStatusHandler}
            />
        </div>
    )
}

export default AvoStoreFilter
